import { render, staticRenderFns } from "./Plantillas.vue?vue&type=template&id=72b12c07"
import script from "./Plantillas.vue?vue&type=script&lang=js"
export * from "./Plantillas.vue?vue&type=script&lang=js"
import style0 from "./Plantillas.vue?vue&type=style&index=0&id=72b12c07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports